import { v4 as uuidv4 } from 'uuid'
import { CONST } from '../../../const/const'
import { IHorseData } from '../../../models/horse/horse.interface'
import { HorseModel } from '../../../models/horse/horse.model'
import { getConvertedData } from '../../../models/interface.helper'
import { getUserFullName } from '../../../helpers/helpers'

import { IUserHorseMappingInterface } from '../../../models/user-horse-mapping/userHorseMapping.interface'
import { UserHorseMappingModel } from '../../../models/user-horse-mapping/userHorseMapping.model'
import FirestoreService from '../../../services/firestoreService'
import { IInputHorseData } from '../../home/types/inputData'
import { IUserInterface } from '../../../models/users/user.interface'

interface ICreateHorseData {
  userData: IUserInterface
  horsePicture: string
  inputData: IInputHorseData
}

const COLLECTIONS = CONST.DATA.FIRESTORE.LATEST.COLLECTIONS

export const createHorseData = async ({ userData, horsePicture, inputData }: ICreateHorseData) => {
  let mapping: IUserHorseMappingInterface | null

  const horseData: IHorseData = {
    horseOwnerId: userData.id,
    horseOwnerName: getUserFullName(userData),
    horseOwnerPicture: userData.userProfilePicture || null,
    horseProfilePicture: horsePicture,
    horseName: `${inputData.name.value}` || '',
    horseBreed: [`${inputData.breed.value}`],
    horseGender: `${inputData.gender.value}` || '',
    horseColor: `${inputData.coloring.value}` || '',
    horseId: uuidv4(),
  }

  let horseToCreate = new HorseModel(horseData)

  const ref = await FirestoreService.createItem(
    COLLECTIONS.HORSES.NAME,
    new HorseModel(horseToCreate).toFirestore()
  )

  horseToCreate.id = ref.id
  horseToCreate = getConvertedData(horseToCreate)

  let docToSave = new UserHorseMappingModel({
    userId: userData.id,
    horseId: (horseToCreate ? horseToCreate.id : null) ?? null,
    isMyHorse: true,
    horseOwnerId: userData.id,
    horseOwnerName: getUserFullName(userData),
    horseOwnerPicture: userData.userProfilePicture || null,
    horseName: horseToCreate.horseName,
    horseZone: horseToCreate.horseZone,
    horseSelectedForCompeletion: true,
    horseNameNGram: horseToCreate?.horseNameNGram,
    horseDiscipline: horseToCreate.horseDiscipline,
    horseProfilePicture: horseToCreate.horseProfilePicture,
  })

  mapping = docToSave.cloneDeep().toFirestore()

  mapping!.id = (
    await FirestoreService.createItem(COLLECTIONS.USER_HORSE_MAPPING.NAME, docToSave.toFirestore())
  )?.id
  return {
    horseToCreate,
  }
}
